<template>
  <div class="waterPark">
    <div class="menuLeft">
      <ul>
        <li :class="{ move: currentIndex === index }" v-for="(item, index) in menuList" :key="index"
          @click="goShow(item, index)">
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </div>
    <div class="ShowOff">
      <div class="currentTitle">{{ currentTitle }}</div>
      <div class="currentInfo">
        <template v-if="currentItem.sections">
          <div v-for="(section, sectionIndex) in currentItem.sections" :key="sectionIndex" class="food-shopping-section">
            <h3>{{ section.title }}</h3>
            <p>{{ section.content }}</p>
            <div class="image-gallery">
              <img 
                v-for="(image, imageIndex) in section.images" 
                :key="imageIndex"
                class="gallery-img" 
                :src="image" 
                :alt="section.title"
                @click="openImagePreview(section.images, imageIndex)"
              />
            </div>
            <div v-if="section.productImages && section.productImages.length" class="image-gallery product-gallery">
              <img 
                v-for="(image, imageIndex) in section.productImages" 
                :key="'product-'+imageIndex"
                class="gallery-img product-img" 
                :src="image" 
                :alt="section.title + ' product'"
                @click="openImagePreview(section.productImages, imageIndex)"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="img">
            <div v-if="Array.isArray(currentImg)" class="image-gallery" :class="{ 'special-events-gallery': currentIndex === 4 }">
              <img 
                v-for="(image, index) in currentImg" 
                :key="index"
                :class="['currentImg', 'gallery-img', { 'full-width-img': currentIndex === 4 && index === 0 }]" 
                :src="image" 
                :alt="$t('us.title')"
                @click="openImagePreview(currentImg, index)"
              />
            </div>
            <img 
              v-else 
              class="currentImg" 
              :src="currentImg" 
              :alt="$t('us.title')" 
            />
          </div>
          <div class="info" :model="currentInfo">
            <div v-for="(item, index) in currentInfo" :key="index" v-html="item"></div>
          </div>
        </template>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <div v-if="showImagePreview" class="image-preview-overlay" @click="closeImagePreview">
      <div class="image-preview-container" @click.stop>
        <!-- 关闭按钮 -->
        <button class="preview-close-btn" @click="closeImagePreview">×</button>
        
        <!-- 主图片显示 -->
        <div class="preview-image-wrapper">
          <img :src="previewImages[currentPreviewIndex]" :alt="'预览图片'" class="preview-image" />
        </div>
        
        <!-- 导航按钮 -->
        <button 
          v-if="previewImages.length > 1" 
          class="preview-nav-btn prev-btn" 
          @click="previousImage"
          :disabled="currentPreviewIndex === 0"
        >
          ‹
        </button>
        <button 
          v-if="previewImages.length > 1" 
          class="preview-nav-btn next-btn" 
          @click="nextImage"
          :disabled="currentPreviewIndex === previewImages.length - 1"
        >
          ›
        </button>
        
        <!-- 缩略图导航 -->
        <div v-if="previewImages.length > 1" class="preview-thumbnails">
          <img 
            v-for="(image, index) in previewImages" 
            :key="index"
            :src="image" 
            :alt="'缩略图'"
            class="preview-thumbnail"
            :class="{ active: index === currentPreviewIndex }"
            @click="currentPreviewIndex = index"
          />
        </div>
        
        <!-- 图片计数 -->
        <div v-if="previewImages.length > 1" class="preview-counter">
          {{ currentPreviewIndex + 1 }} / {{ previewImages.length }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    menuList() {
      return [
        {
          id: 1,
          value: this.$t('us.companyIntro'),
          img: require('@/assets/us/us.jpg'),
          info: {
            val1: this.$t('us.companyIntroText'),
          },
        },
        {
          id: 2,
          value: this.$t('us.trafficAndHotel'),
          img: require('@/assets/us/traffic.jpg'),
          info: {
            val1: this.$t('us.trafficInfo.huangshiStation'),
            val2: this.$t('us.trafficInfo.huangshiNorthStation'),
            val3: this.$t('us.trafficInfo.dayeNorthStation'),
            val4: this.$t('us.trafficInfo.hotels'),
          },
        },
        {
          id: 3,
          value: this.$t('us.foodAndShopping'),
          sections: [
            {
              title: this.$t('us.foodAndShoppingSections.brandDining.title'),
              content: this.$t('us.foodAndShoppingSections.brandDining.content'),
              images: [
                require('@/assets/us/美食购物/品牌餐饮/2df298322f9e621228c22b1391cfb574.jpg'),
                require('@/assets/us/美食购物/品牌餐饮/a57f467b9b54eaf3d2d3bc4f7491c137.jpg'),
              ],
              productImages: [
                require('@/assets/us/美食购物/产品图/品牌餐饮/韩式炸鸡/39c5bab3ff0f0ac6fab444936e264564.jpg'),
                require('@/assets/us/美食购物/产品图/品牌餐饮/韩式炸鸡/805dafd08d1698fcc13f963aa41e3e0d.jpg'),
                require('@/assets/us/美食购物/产品图/品牌餐饮/韩式炸鸡/850e9fa82bc98492eef5591c7b287c47.jpg'),
                require('@/assets/us/美食购物/产品图/品牌餐饮/韩式炸鸡/f130e9fbb647473a395db02703866aae.jpg'),
                require('@/assets/us/美食购物/产品图/品牌餐饮/吾饮良品/7e682552-0dfe-428a-8a9d-d6076b08b8c4.jpg'),
                require('@/assets/us/美食购物/产品图/品牌餐饮/吾饮良品/b207afaa-654d-4b7e-b520-1c542075db5c.jpg'),
                require('@/assets/us/美食购物/产品图/品牌餐饮/吾饮良品/f4f57bbc-8a7c-4ec1-8969-0f3eca643782.jpg'),
              ]
            },
            {
              title: this.$t('us.foodAndShoppingSections.themeDining.title'),
              content: this.$t('us.foodAndShoppingSections.themeDining.content'),
              images: [
                require('@/assets/us/美食购物/主题餐厅/9cedac4302ce93256ee77308f4593ca3.jpg'),
                require('@/assets/us/美食购物/主题餐厅/667958ae66802877ffb45a6f566fc8d7.jpg'),
                require('@/assets/us/美食购物/主题餐厅/44948573fe383e65117c8404f06b44d2.jpg'),
              ],
              productImages: [
                require('@/assets/us/美食购物/产品图/主题餐厅/龙妈餐厅/微信图片_20251028123223_206_595.jpg'),
                require('@/assets/us/美食购物/产品图/主题餐厅/龙妈餐厅/微信图片_20251028123229_207_595.jpg'),
                require('@/assets/us/美食购物/产品图/主题餐厅/龙妈餐厅/微信图片_20251028123237_208_595.jpg'),
                require('@/assets/us/美食购物/产品图/主题餐厅/龙妈餐厅/微信图片_20251028123244_209_595.jpg'),
                require('@/assets/us/美食购物/产品图/主题餐厅/龙妈餐厅/微信图片_20251028123250_210_595.jpg'),
                require('@/assets/us/美食购物/产品图/主题餐厅/龙妈餐厅/微信图片_20251028123256_211_595.jpg'),
                require('@/assets/us/美食购物/产品图/主题餐厅/星际补给站/微信图片_20251027135744_1189_62.jpg'),
                require('@/assets/us/美食购物/产品图/主题餐厅/星际补给站/微信图片_20251027135745_1190_62.jpg'),
                require('@/assets/us/美食购物/产品图/主题餐厅/星际补给站/微信图片_20251027135745_1191_62.jpg'),
                require('@/assets/us/美食购物/产品图/主题餐厅/星际补给站/微信图片_20251027135746_1192_62.jpg'),
                require('@/assets/us/美食购物/产品图/主题餐厅/星际补给站/微信图片_20251027135747_1193_62.jpg'),
              ]
            },
            {
              title: this.$t('us.foodAndShoppingSections.creativeGifts.title'),
              content: this.$t('us.foodAndShoppingSections.creativeGifts.content'),
              images: [
                require('@/assets/us/美食购物/文创礼品/8bce6712b80a8933ddd618806afdbf4d.jpg'),
                require('@/assets/us/美食购物/文创礼品/c6cf35116a634c7d1145d3e1283a8c96.jpg'),
                require('@/assets/us/美食购物/文创礼品/e16dc1e316479a4442791809814984c3.jpg'),
                require('@/assets/us/美食购物/文创礼品/e37722a0a5745b80d60b4f4eb1e43d3e.jpg'),
              ],
              productImages: [
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/背包恐龙公仔.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/大眼睛恐龙公仔.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/仿真电动三角恐龙.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/仿真恐龙背包.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/仿真恐龙公仔-2.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/仿真恐龙公仔.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/粉绿CP恐龙公仔.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/粉色翼龙公仔.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/恐龙带盖陶瓷杯.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/恐龙蛋翼龙公仔-2.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/恐龙蛋翼龙公仔.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/恐龙计时器.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/恐龙K歌机.jpg'),
                require('@/assets/us/美食购物/产品图/文创礼品/恐龙有礼单件图片/天然水晶生肖.jpg'),
              ]
            },
            {
              title: this.$t('us.foodAndShoppingSections.groceryStore.title'),
              content: this.$t('us.foodAndShoppingSections.groceryStore.content'),
              images: [
                require('@/assets/us/美食购物/杂货铺/4c7144b4-a94c-417e-976d-bcbb14781c9f.jpg'),
                require('@/assets/us/美食购物/杂货铺/863243460ad6346432651ec169c46238.jpg'),
                require('@/assets/us/美食购物/杂货铺/5643758606faf49dffd7927d2f15e98c.jpg'),
              ],
              productImages: [
              ]
            },
            {
              title: this.$t('us.foodAndShoppingSections.specialFood.title'),
              content: this.$t('us.foodAndShoppingSections.specialFood.content'),
              images: [
                require('@/assets/us/美食购物/特色美食/1ad08b216cc6707245f7f561165848ee.jpg'),
                require('@/assets/us/美食购物/特色美食/3de7bedac03c022359e21c8146bd64f0.jpg'),
                require('@/assets/us/美食购物/特色美食/5b0cebd5-408b-40a6-9e62-ba918269b90a.jpg'),
                require('@/assets/us/美食购物/特色美食/8629b52fdc50bd24e5d3aa50a40f0d11.jpg'),
                require('@/assets/us/美食购物/特色美食/88551d56866e66b28332dc7f2bcb97c3.jpg'),
                require('@/assets/us/美食购物/特色美食/bb5037e414cb27b0e7d0f7ea87391da1.jpg'),
                require('@/assets/us/美食购物/特色美食/c9b8dea7626427ba7f9d74c65747715b.jpg'),
                require('@/assets/us/美食购物/特色美食/f52f4348b533a9857f2b7eab3c27c2cc.jpg'),
              ],
              productImages: [
                require('@/assets/us/美食购物/产品图/特色美食/暴龙汉堡/6fbcf9a7ca655ec85c3eed791e1a51d0.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/暴龙汉堡/7989af920d5a80ed0ea3969935c56e63.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/暴龙汉堡/ce6a785606400e191bf439bcb83a05d8.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/暴龙汉堡/e47ab91cd10d8cb3cdcded6c2a995310.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/暴龙汉堡/ee3706a82562f6954ba29bde79c80b11.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/飞翼咖啡/15b6cf59c0f5cfdd0268e76f3bcaace4_副本.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/飞翼咖啡/f2d8df897012366240dfa2515dadc4f4_副本.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/飞翼咖啡/36cba4fd392f73a5f1790cdad2ef0cc3.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/飞翼咖啡/5b1d58f3ed40fe4be6acb8fb45e89f1d.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/飞翼咖啡/5df58a06fb1491ec9266938a39fc48b9.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/飞翼咖啡/e880c7f6e6cbc49c1b3d61b4601bfd92.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/福牛面馆/032a2de5ddadcd49c4a6d25dfb1fba2c.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/福牛面馆/838b415b33a70b1c99f2480fc0e654fb.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/福牛面馆/9fdba5ceafcc3f96a4b9042b6727c12e.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/福牛面馆/c951d7bf8373ce2c373471df0b19db59.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/福牛面馆/ea8cf0cbed7ab7be554c8cd6f2623d72_副本_副本.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/矿龙列车/38f9c0ff4c8cceb80e5f38e0de92f6aa_副本.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/矿龙列车/5e2c1b41961cb82febe72b6042bba262_副本.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/矿龙列车/8ee16eb3276ddbb63f361b4acc2cd1f6_副本.jpg'),
                require('@/assets/us/美食购物/产品图/特色美食/矿龙列车/c87b1a7b5b48e90295c210b4d40ee058_副本.jpg'),
              ]
            },
            {
              title: this.$t('us.foodAndShoppingSections.foodCart.title'),
              content: this.$t('us.foodAndShoppingSections.foodCart.content'),
              images: [
                require('@/assets/us/美食购物/特色餐车/4a42cc07eecd46c0ebef7d28b36fcf69.jpg'),
                require('@/assets/us/美食购物/特色餐车/83d5092976183f25f54ddc6ef5aa1f57.jpg'),
                require('@/assets/us/美食购物/特色餐车/93aec1f246ac943ad85673713e1eb927.jpg'),
                require('@/assets/us/美食购物/特色餐车/99f94f1bf14b3fc504bcd836be0d016d.jpg'),
                require('@/assets/us/美食购物/特色餐车/b9a7ce37bc0bc69a97858ab6c518798b.jpg'),
                require('@/assets/us/美食购物/特色餐车/b315e972163b10ad6b562a3b1e1c6e58.jpg'),
                require('@/assets/us/美食购物/特色餐车/c6a8af26374a65acdd18442dbef64b96.jpg'),
                require('@/assets/us/美食购物/特色餐车/d6562d0d74d10958c8d4f7f6f111b347.jpg'),
              ],
              productImages: [
                require('@/assets/us/美食购物/产品图/特色餐车/0f39f91e8c13c0e5a128438ab5a336f2.jpg'),
                require('@/assets/us/美食购物/产品图/特色餐车/351acd125f46805aca8bc8f7d1e9ba60.jpg'),
                require('@/assets/us/美食购物/产品图/特色餐车/微信图片_20251029163307_18_62.jpg'),
                require('@/assets/us/美食购物/产品图/特色餐车/微信图片_20251029163310_21_62.jpg'),
                require('@/assets/us/美食购物/产品图/特色餐车/微信图片_20251029163311_22_62.jpg'),
                require('@/assets/us/美食购物/产品图/特色餐车/c6e96cca4df78768d40a5d73bb7340d5.jpg'),
              ]
            },
          ],
        },
        {
          id: 4,
          value: this.$t('us.businessHours'),
          img: require('@/assets/us/businesshours.png'),
          info: {
            val1: this.$t('us.openingHours')
          },
        },
        {
          id: 5,
          value: this.$t('us.specialEvents'),
          title: this.$t('us.specialEventsInfo'),
          img: [
            require('@/assets/us/specialEvents/long_1.jpg'),
            require('@/assets/us/specialEvents/001.jpg'),
            require('@/assets/us/specialEvents/002.jpg'),
            require('@/assets/us/specialEvents/003.jpg'),
            require('@/assets/us/specialEvents/005.jpg'),
            require('@/assets/us/specialEvents/WechatIMG6042.jpg'),
            require('@/assets/us/specialEvents/WechatIMG6043.jpg'),
            require('@/assets/us/specialEvents/微信图片_20240906111436.jpg'),
            require('@/assets/us/specialEvents/微信图片_20251001102858_1951_207.jpg'),
            require('@/assets/us/specialEvents/微信图片_20251001102859_1952_207.jpg'),
            require('@/assets/us/specialEvents/微信图片_20251001142706_1974_207.jpg'),
            require('@/assets/us/specialEvents/微信图片_20251007143222_2271_2.jpg'),
          ],
          // info: {
          //   val1: this.$t('us.specialEventsInfo')
          // },
        },
      ]
    },
    currentTitle() {
      const currentItem = this.menuList[this.currentIndex]
      return currentItem.title || currentItem.value
    },
    currentInfo() {
      return this.menuList[this.currentIndex].info
    },
    currentImg() {
      return this.menuList[this.currentIndex].img
    },
    currentItem() {
      return this.menuList[this.currentIndex]
    },
  },
  data() {
    return {
      currentIndex: 0,
      showImagePreview: false,
      previewImages: [],
      currentPreviewIndex: 0
    }
  },
  methods: {
    goShow(item, index) {
      this.currentIndex = index
    },
    scrollToSpecialEvents() {
      this.currentIndex = 4
    },
    openImagePreview(images, startIndex = 0) {
      this.previewImages = images
      this.currentPreviewIndex = startIndex
      this.showImagePreview = true
      // 禁止背景滚动
      document.body.style.overflow = 'hidden'
    },
    closeImagePreview() {
      this.showImagePreview = false
      this.previewImages = []
      this.currentPreviewIndex = 0
      // 恢复背景滚动
      document.body.style.overflow = 'auto'
    },
    nextImage() {
      if (this.currentPreviewIndex < this.previewImages.length - 1) {
        this.currentPreviewIndex++
      }
    },
    previousImage() {
      if (this.currentPreviewIndex > 0) {
        this.currentPreviewIndex--
      }
    }
  },
  mounted() {
    // 监听键盘事件
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    // 清理事件监听
    document.removeEventListener('keydown', this.handleKeydown)
    // 确保恢复滚动
    document.body.style.overflow = 'auto'
  },
  methods: {
    goShow(item, index) {
      this.currentIndex = index
    },
    scrollToSpecialEvents() {
      this.currentIndex = 4
    },
    openImagePreview(images, startIndex = 0) {
      this.previewImages = images
      this.currentPreviewIndex = startIndex
      this.showImagePreview = true
      // 禁止背景滚动
      document.body.style.overflow = 'hidden'
    },
    closeImagePreview() {
      this.showImagePreview = false
      this.previewImages = []
      this.currentPreviewIndex = 0
      // 恢复背景滚动
      document.body.style.overflow = 'auto'
    },
    nextImage() {
      if (this.currentPreviewIndex < this.previewImages.length - 1) {
        this.currentPreviewIndex++
      }
    },
    previousImage() {
      if (this.currentPreviewIndex > 0) {
        this.currentPreviewIndex--
      }
    },
    handleKeydown(event) {
      if (!this.showImagePreview) return
      
      switch (event.key) {
        case 'Escape':
          this.closeImagePreview()
          break
        case 'ArrowLeft':
          this.previousImage()
          break
        case 'ArrowRight':
          this.nextImage()
          break
      }
    }
  },
}
</script>

<style lang="less" scoped>
.food-shopping-section {
  margin-bottom: 2vw;
  
  h3 {
    font-size: 1.25vw;
    color: #85b62c;
    margin-bottom: 0.5vw;
  }

  p {
    font-size: 0.9vw;
    color: #583c3c;
    margin-bottom: 1vw;
  }

  .image-gallery {
    margin-bottom: 1vw;
  }

  .product-gallery {
    margin-top: 1vw;
  }

  .image-gallery {
    display: flex;
    overflow-x: auto;
    gap: 1vw;
    padding-bottom: 1vw;

    &::-webkit-scrollbar {
      height: 0.5vw;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #85b62c;
      border-radius: 0.25vw;
    }

    .gallery-img {
      flex: 0 0 auto;
      width: 15vw;
      height: 10vw;
      object-fit: cover;
      border-radius: 0.5vw;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .product-img {
    width: 6vw !important;
    height: 6vw !important;
  }
}
.waterPark {
  margin-top: 4.53vw; /* 87px at 1920px */
  padding: 1.56vw 0; /* 30px at 1920px */
  width: 62.5vw; /* 1200px at 1920px */
  display: flex;
  .menuLeft {
    width: 13.54vw; /* 260px at 1920px */
    height: 31.25vw; /* 600px at 1920px */
    background: #ffffff;
    border: 0.05vw solid #eee; /* 1px at 1920px */
    ul {
      list-style-type: none;
      font-size: 1.04vw; /* 20px at 1920px */
      color: #666666;
      // margin: 0 1.04vw; /* 20px at 1920px */
      li {
        height: 3.49vw; /* 67px at 1920px */
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 1.04vw; /* 20px at 1920px */
        cursor: pointer;
        span {
          height: 3.49vw; /* 67px at 1920px */
          width: 11.46vw; /* 220px at 1920px */
          border-top: 0.05vw solid #eee; /* 1px at 1920px */
          line-height: 3.49vw; /* 67px at 1920px */
        }
      }
      li:nth-child(1) {
        span {
          border: none;
        }
      }
      .move {
        height: 3.39vw; /* 65px at 1920px */
        background: #85b62c;
        color: #fff;
        position: relative;
        &::before {
          display: block;
          content: ' ';
          background-color: #fff;
          height: 0.21vw; /* 4px at 1920px */
          width: 0.21vw; /* 4px at 1920px */
          position: absolute;
          top: 1.67vw; /* 32px at 1920px */
          left: 3.65vw; /* 70px at 1920px */
        }
        &::after {
          display: block;
          content: ' ';
          background-color: #fff;
          height: 0.21vw; /* 4px at 1920px */
          width: 0.21vw; /* 4px at 1920px */
          position: absolute;
          top: 1.67vw; /* 32px at 1920px */
          right: 3.65vw; /* 70px at 1920px */
        }
      }
    }
  }
  .ShowOff {
    width: 100%;
    height: 100%;
    margin: 0 33px;
    .currentTitle {
      height: 3.39vw; /* 65px at 1920px */
      line-height: 3.39vw; /* 65px at 1920px */
      width: 100%;
      font-size: 1.15vw; /* 22px at 1920px */
      color: #583c3c;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1.04vw; /* 20px at 1920px */
      
      &::before {
        content: '';
        flex: 1;
        max-width: 6.25vw; /* 120px at 1920px */
        height: 0.31vw; /* 6px at 1920px */
        background: #85b62c;
        border-radius: 0.16vw; /* 3px at 1920px */
      }
      
      &::after {
        content: '';
        flex: 1;
        max-width: 6.25vw; /* 120px at 1920px */
        height: 0.31vw; /* 6px at 1920px */
        background: #85b62c;
        border-radius: 0.16vw; /* 3px at 1920px */
      }
    }
    .currentInfo {
      width: 100%;

      .img {
        width: 100%;
        margin-bottom: 1.56vw; /* 30px at 1920px */
        
        .currentImg {
          border-radius: 0.52vw !important; /* 10px at 1920px */
          height: 15.63vw; /* 300px at 1920px */
          width: 31.25vw; /* 600px at 1920px */
        }
        
        .image-gallery {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(15vw, 1fr));
          gap: 1vw;
          width: 100%;
          
          .gallery-img {
            width: 100%;
            height: 12vw; /* 230px at 1920px */
            object-fit: cover;
            border-radius: 0.52vw !important; /* 10px at 1920px */
            transition: transform 0.3s ease;
            cursor: pointer;
            
            &:hover {
              transform: scale(1.05);
            }
          }
        }
        
        .special-events-gallery {
          display: flex;
          flex-wrap: wrap;
          gap: 1vw;
          
          .gallery-img {
            width: calc(50% - 0.5vw);
            height: 15vw;
          }
          
          .full-width-img {
            width: 100%;
            height: 20vw;
          }
        }
      }
      .info {
        text-align: left;
        text-indent: 2em;
        color: #583c3c;
        font-size: 0.73vw; /* 14px at 1920px */
        line-height: 2.08vw; /* 40px at 1920px */
      }
    }
  }
}

/* 图片预览弹窗样式 */
.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.image-preview-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-close-btn {
  position: absolute;
  top: -3vw;
  right: -1vw;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 2.5vw;
  height: 2.5vw;
  font-size: 1.5vw;
  font-weight: bold;
  cursor: pointer;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: white;
    transform: scale(1.1);
  }
}

.preview-image-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 80vw;
  max-height: 70vh;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 0.5vw;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.5);
  animation: scaleIn 0.3s ease;
}

.preview-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 3vw;
  height: 3vw;
  font-size: 2vw;
  font-weight: bold;
  cursor: pointer;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: white;
    transform: translateY(-50%) scale(1.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.prev-btn {
    left: -4vw;
  }

  &.next-btn {
    right: -4vw;
  }
}

.preview-thumbnails {
  display: flex;
  gap: 0.5vw;
  margin-top: 1vw;
  max-width: 80vw;
  overflow-x: auto;
  padding: 0.5vw;

  &::-webkit-scrollbar {
    height: 0.3vw;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 0.15vw;
  }
}

.preview-thumbnail {
  width: 4vw;
  height: 3vw;
  object-fit: cover;
  border-radius: 0.3vw;
  cursor: pointer;
  opacity: 0.6;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    opacity: 0.8;
    transform: scale(1.05);
  }

  &.active {
    opacity: 1;
    border: 0.15vw solid #85b62c;
  }
}

.preview-counter {
  position: absolute;
  top: -2.5vw;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 0.3vw 0.8vw;
  border-radius: 1vw;
  font-size: 0.8vw;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { 
    opacity: 0;
    transform: scale(0.9);
  }
  to { 
    opacity: 1;
    transform: scale(1);
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .preview-close-btn {
    top: -5vw;
    right: -2vw;
    width: 6vw;
    height: 6vw;
    font-size: 4vw;
  }

  .preview-nav-btn {
    width: 8vw;
    height: 8vw;
    font-size: 5vw;

    &.prev-btn {
      left: -10vw;
    }

    &.next-btn {
      right: -10vw;
    }
  }

  .preview-thumbnail {
    width: 8vw;
    height: 6vw;
  }

  .preview-counter {
    top: -6vw;
    font-size: 3vw;
    padding: 1vw 2vw;
  }
}
</style>
